export const FETCH_FILTERS = 'FETCH_FILTERS'
export const RECEIVE_FILTERS = 'RECEIVE_FILTERS'
